/**
 * Utility functions for validation error messages
 */
export class ValidationUtils {
  
  /**
   * Generates a generic "no data available" message
   * @param dataType - The type of data that's missing (e.g., 'patient data', 'report data', 'vital data')
   * @returns Formatted "no data available" message
   */
  static getNoDataMessage(dataType: string = 'data'): string {
    return `No ${dataType} available.`;
  }
}
